import React from 'react';
import { useParams } from 'react-router';
import { NavLink } from 'react-router-dom';

import { Breadcrumb } from '@shared/components/bootstrap';

import { PageHeader } from '@admin/components/helpers/page_header';
import { Spinner } from '@admin/components/spinner';
import { useNavigate } from '@admin/hooks/use_navigate';
import { useTitle } from '@admin/hooks/use_title';
import { client } from '@admin/libraries/apollo';
import { useRedirectQuery, useRedirectUpdateMutation, type Redirect__Input } from '@admin/schema';

import { RedirectForm } from './redirect_form';

export const RedirectEdit: React.FC = () => {
  useTitle('Edit Redirect');
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { data: defaults } = useRedirectQuery({ client, variables: { id } });
  const [execute, { data, loading }] = useRedirectUpdateMutation({ client });

  const save = async (input: Redirect__Input) => {
    if (loading) return;

    const response = await execute({ variables: { id, input } });
    const redirect = response?.data?.redirectUpdate.redirect;
    if (!redirect) return;
    navigate(`/marketing/redirects`);
  };

  if (!defaults) return <Spinner />;

  return (
    <>
      <PageHeader>
        <Breadcrumb>
          <Breadcrumb.Item>
            <NavLink to="/marketing/redirects">Redirects</NavLink>
          </Breadcrumb.Item>
          <Breadcrumb.Item>Edit</Breadcrumb.Item>
        </Breadcrumb>
      </PageHeader>
      <RedirectForm loading={loading} error={data?.redirectUpdate.error} save={save} defaults={defaults.redirect} />
    </>
  );
};
